import { FC } from 'react';
import { Form, Payment } from '@repo-level/core-front';

import { OfUnion } from 'types/common';
import { CRYPTO_IDENTIFIER, SECURE_3D_IDENTIFIER } from '../helpers';
import { ScFieldBanner } from './styled';

export interface IScFieldBannerProps {
  cardMethod: boolean;
  isCrypto: boolean;
  isDeposit: boolean;
}

export const FieldBanner: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Banner] & {
    paymentAction: Payment.Action;
    htmlContent: string;
  }
> = ({ identifier, paymentAction, htmlContent }) => {
  const isDeposit = paymentAction === Payment.Action.Deposit;
  const is3dSecureId = identifier.includes(SECURE_3D_IDENTIFIER);
  const isCrypto = identifier.includes(CRYPTO_IDENTIFIER);

  return (
    <ScFieldBanner
      cardMethod={is3dSecureId && isDeposit}
      isCrypto={isCrypto && isDeposit}
      isDeposit={isDeposit}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};
